module.exports = __webpack_public_path__ + "static/media/IEEE_NUS_Student Branch_logo.e38b00b0.jpeg";